import {About, Achievement, Experience, Project, Skill} from './Partials';

const Home = () => {
	return (
		<>
			<About />
			<Project />
			<Achievement />
			<Experience />
			<Skill />
		</>  
	);
}

export default Home;